function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "3AC14108-F6A9-4CBE-B031-AADEAD1A1478");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with sketchtool.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Concept-graphic",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Smart-Customer-Acquistision",
  transform: "translate(-721.000000, -3784.000000)",
  strokeWidth: 1.5
}, React.createElement("g", {
  id: "ic-Optimized",
  transform: "translate(720.000000, 3785.000000)"
}, React.createElement("g", {
  id: "bg",
  fill: "#FFFFFF",
  stroke: "#DADADA"
}, React.createElement("polygon", {
  id: "Polygon",
  points: "42 3 78.373067 24 78.373067 66 42 87 5.62693304 66 5.62693304 24"
}), React.createElement("path", {
  d: "M42,84 C43.6568542,84 45,85.3431458 45,87 C45,88.6568542 43.6568542,90 42,90 C40.3431458,90 39,88.6568542 39,87 C39,85.3431458 40.3431458,84 42,84 Z M80.3442101,63.5 C81.779088,64.3284271 82.2707135,66.1631983 81.4422863,67.5980762 C80.6138592,69.0329541 78.779088,69.5245795 77.3442101,68.6961524 C75.9093323,67.8677253 75.4177068,66.0329541 76.2461339,64.5980762 C77.074561,63.1631983 78.9093323,62.6715729 80.3442101,63.5 Z M8.22500925,64.5 C9.05343638,65.9348779 8.56181091,67.7696491 7.12693304,68.5980762 C5.69205517,69.4265033 3.85728395,68.9348779 3.02885683,67.5 C2.2004297,66.0651221 2.69205517,64.2303509 4.12693304,63.4019238 C5.56181091,62.5734967 7.39658213,63.0651221 8.22500925,64.5 Z M7.59807621,21.5 C9.03295408,22.3284271 9.52457955,24.1631983 8.69615242,25.5980762 C7.8677253,27.0329541 6.03295408,27.5245795 4.59807621,26.6961524 C3.16319834,25.8677253 2.67157288,24.0329541 3.5,22.5980762 C4.32842712,21.1631983 6.16319834,20.6715729 7.59807621,21.5 Z M80.9711432,22.5 C81.7995703,23.9348779 81.3079448,25.7696491 79.873067,26.5980762 C78.4381891,27.4265033 76.6034179,26.9348779 75.7749907,25.5 C74.9465636,24.0651221 75.4381891,22.2303509 76.873067,21.4019238 C78.3079448,20.5734967 80.142716,21.0651221 80.9711432,22.5 Z M42,0 C43.6568542,0 45,1.34314575 45,3 C45,4.65685425 43.6568542,6 42,6 C40.3431458,6 39,4.65685425 39,3 C39,1.34314575 40.3431458,0 42,0 Z",
  id: "Combined-Shape"
})), React.createElement("g", {
  id: "l-settings",
  transform: "translate(21.000000, 26.000000)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("path", {
  d: "M19.6,33.6 L5.6,33.6 C2.5074,33.6 0,31.0926 0,28 L0,28 L19.6,28",
  id: "Path",
  stroke: "#27294F"
}), React.createElement("path", {
  d: "M4.2,22.4 L4.2,2.8 C4.2,1.253 5.453,0 7,0 L35,0 C36.547,0 37.8,1.253 37.8,2.8 L37.8,15.4",
  id: "Path",
  stroke: "#27294F"
}), React.createElement("line", {
  x1: 19.6,
  y1: 5.6,
  x2: 22.4,
  y2: 5.6,
  id: "Path",
  stroke: "#27294F"
}), React.createElement("circle", {
  id: "Oval",
  stroke: "#0276F1",
  cx: 33.6,
  cy: 29.4,
  r: 5.6
}), React.createElement("line", {
  x1: 33.6,
  y1: 23.8,
  x2: 33.6,
  y2: 21,
  id: "Path",
  stroke: "#0276F1"
}), React.createElement("line", {
  x1: 37.5592,
  y1: 25.4408,
  x2: 39.5402,
  y2: 23.4598,
  id: "Path",
  stroke: "#0276F1"
}), React.createElement("line", {
  x1: 39.2,
  y1: 29.4,
  x2: 42,
  y2: 29.4,
  id: "Path",
  stroke: "#0276F1"
}), React.createElement("line", {
  x1: 37.5592,
  y1: 33.3592,
  x2: 39.5402,
  y2: 35.3402,
  id: "Path",
  stroke: "#0276F1"
}), React.createElement("line", {
  x1: 33.6,
  y1: 35,
  x2: 33.6,
  y2: 37.8,
  id: "Path",
  stroke: "#0276F1"
}), React.createElement("line", {
  x1: 29.6408,
  y1: 33.3592,
  x2: 27.6598,
  y2: 35.3402,
  id: "Path",
  stroke: "#0276F1"
}), React.createElement("line", {
  x1: 28,
  y1: 29.4,
  x2: 25.2,
  y2: 29.4,
  id: "Path",
  stroke: "#0276F1"
}), React.createElement("line", {
  x1: 29.6408,
  y1: 25.4408,
  x2: 27.6598,
  y2: 23.4598,
  id: "Path",
  stroke: "#0276F1"
})))));

var SvgOptimized = function SvgOptimized(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "82px",
    height: "92px",
    viewBox: "0 0 82 92",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgOptimized, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };